import type { FC } from 'react';
import type { TrackerCategory } from '../../../../common/tracking/trackerService';
import {
  CommonDateInputField,
  type CommonDateInputFieldProps,
} from '../../../../common-ui/form-fields/CommonDateInputField';
import { getFieldProps } from '../../../../common-ui/form-fields/getFieldProps';
import type { CreateIntermodalBookingFormModelDateKeys } from '../../../../services/intermodal/createIntermodalReducer';
import { useCreateIntermodalField } from '../../hooks/useCreateIntermodalField';

interface CreateIntermodalDateInputFieldProps
  extends Omit<CommonDateInputFieldProps, 'onValueChange' | 'trackerAction' | 'value'> {
  name: CreateIntermodalBookingFormModelDateKeys;
  trackerCategory: TrackerCategory;
}

export const CreateIntermodalDateInputField: FC<CreateIntermodalDateInputFieldProps> = ({
  name,
  ...props
}) => {
  const fieldProps = useCreateIntermodalField(name);

  return <CommonDateInputField {...props} {...getFieldProps(props, fieldProps)} />;
};
